import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";
import { updateConfiguration } from "../../../api/endpoint";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../../../components/loader";

const UpdateSocialModal = ({
  isUpdateOpen,
  closeUpdateModal,
  fetchConfig,
  socialMedia,
}) => {
  const [social, setSocial] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { config } = useSelector((state) => state.config);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    if (config?.contactInfo?.[socialMedia]) {
      setSocial(config?.contactInfo?.[socialMedia]);
    } else {
      setSocial("");
    }
  }, [config?.contactInfo?.[socialMedia]]);

  const updateConfig = async (e) => {
    e.preventDefault();
    if (!social) {
      setError(`${socialMedia} Link Required`);
      return;
    }

    const newConfig = {
      ...config,
      contactInfo: {
        ...config?.contactInfo,
        [socialMedia]: social,
      },
    };
    try {
      setLoading(true);
      await axios.post(updateConfiguration, newConfig, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      toast.success(`${socialMedia} Updated Successfully`);
      closeUpdateModal();
      fetchConfig();
    } catch (error) {
      toast.error(`Error Updating ${socialMedia}`);
      console.error(`Error Updating ${socialMedia}`, error);
    } finally {
      setLoading(false);
    }
  };

  const capitalize = (word) => {
    if (!word) return "";
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  };

  return (
    <>
      {loading && <Loader />}
      <Modal show={isUpdateOpen} onHide={closeUpdateModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update {capitalize(socialMedia)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input
            type="text"
            label={`${capitalize(socialMedia)} Link`}
            placeholder={`Enter ${capitalize(socialMedia)} Link`}
            value={social}
            onChange={(e) => setSocial(e.target.value)}
          />
          {error && <div className="text-danger">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button text="Save Changes" callBack={updateConfig} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateSocialModal;
